/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

/**
 * Transient model pro médium.
 * @typedef {import('./medium-attrs').MediumAttrs
 *   & import('../stringable').Stringable // Metoda toString v medium-resource.js.
 * } Medium
 */

/**
 * @typedef {string} URI
 */

/**
 * Vrátí uri daného media. Pokud uri není dostupné
 * (stará verze Ki-Wi Server nebo Webové/Kioskové medium),
 * tak vrátí zpětně kompatibilně URL.
 * @param {Medium} medium
 * @returns {string}
 */
export function getUri(medium) {
  return medium.uri ?? medium.url;
}

// TODO: Nyní triviální funkce, takže skoro ke zrušení. Na druhou stranu,
// alespoň jde snadno najít místa modifikací.
/**
 * Nalinkuje asset (perzistentně uložená entita z JSData) do Medium (transient doménový objekt).
 * @param {Pick<Medium, 'asset'>} medium
 * @param {import('../asset/asset').Asset | undefined} asset
 */
export function linkAsset(medium, asset) {
  medium.asset = asset;
}
